<template>
  <div
    class="
      absolute
      -top-2
      -left-1
      w-5
      h-5
      bg-red-600
      rounded-full
      border border-white
      font-medium
      text-md
      leading-5
    "
  >
    !
  </div>
</template>
<script>
export default {
  name: 'DeviceNotConnectedBadge',
};
</script>
